import { Icon } from 'ui';
import { type PostType, useHeaderPostImage } from './hooks';

type P = {
  postType: PostType;
  type?: 'checked' | 'selected' | 'unchecked';
};

const HeaderImage = ({ postType, type }: P) => {
  const getHeaderPostImage = useHeaderPostImage();

  switch (type) {
    case 'checked':
    case 'unchecked':
      return <Icon color="success" icon="check-green" size="middle" />;
    case 'selected':
      return getHeaderPostImage(postType);
    case undefined:
      return undefined;
    default:
      return undefined;
  }
};

export default HeaderImage;
